import { computed, ref } from 'vue';
import throttle from 'lodash.throttle';

export function useBreakpoints () {
    const computedStyle = getComputedStyle(document.body);

    const breakpoints = {
        horizontal: {
            xl: parseInt(computedStyle.getPropertyValue('--bXl')),
            lg: parseInt(computedStyle.getPropertyValue('--bLg')),
            md: parseInt(computedStyle.getPropertyValue('--bMd')),
            sm: parseInt(computedStyle.getPropertyValue('--bSm')),
            xs: parseInt(computedStyle.getPropertyValue('--bXs')),
        },
        vertical: {
            xl: parseInt(computedStyle.getPropertyValue('--bHXl')),
            lg: parseInt(computedStyle.getPropertyValue('--bHLg')),
            md: parseInt(computedStyle.getPropertyValue('--bHMd')),
            sm: parseInt(computedStyle.getPropertyValue('--bHSm')),
            xs: parseInt(computedStyle.getPropertyValue('--bHXs')),
        },
    };

    const windowWidth = ref(window.innerWidth);
    const windowHeight = ref(window.innerHeight);

    const isXl = computed(() => windowWidth.value < breakpoints.horizontal.xl);
    const isLg = computed(() => windowWidth.value < breakpoints.horizontal.lg);
    const isMd = computed(() => windowWidth.value < breakpoints.horizontal.md);
    const isSm = computed(() => windowWidth.value < breakpoints.horizontal.sm);
    const isXs = computed(() => windowWidth.value < breakpoints.horizontal.xs);

    const isHXl = computed(() => windowHeight.value < breakpoints.vertical.xl);
    const isHLg = computed(() => windowHeight.value < breakpoints.vertical.lg);
    const isHMd = computed(() => windowHeight.value < breakpoints.vertical.md);
    const isHSm = computed(() => windowHeight.value < breakpoints.vertical.sm);
    const isHXs = computed(() => windowHeight.value < breakpoints.vertical.xs);

    const breakpointHorizontal = computed(() => {
        return Object.entries(breakpoints.horizontal).reverse().find(([_, value]) => windowWidth.value < value)?.[0] ?? 'default';
    });

    const setCssVars = () => {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
    };

    const onResize = throttle(() => {
        windowWidth.value = window.innerWidth;
        windowHeight.value = window.innerHeight;
        setCssVars();
    }, 500);

    return {
        breakpoints,
        windowWidth,
        windowHeight,
        isXl,
        isLg,
        isMd,
        isSm,
        isXs,
        isHXl,
        isHLg,
        isHMd,
        isHSm,
        isHXs,
        breakpointHorizontal,
        setCssVars,
        onResize,
    };
}
